import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { reelsPath } from '../paths';

/** Fallback: send /ready into the single CreatingReel loader. */
export default function Readiness() {
  const { sessionId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    navigate(reelsPath('rendering', sessionId), { replace: true });
  }, [sessionId, navigate]);

  return null;
}
